var map = {
	"./Golvsliparna.png": "dcc7",
	"./Herus.png": "fe19",
	"./Monki-logo.png": "ba9b",
	"./Solklar_logo.png": "9e19",
	"./ekonomistyrning_logo.png": "7f00",
	"./nordic-transport.png": "b28a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7085";